export const hotelRoomBlocksPageData = {
  seo: {
    title: 'Hotel Room Blocks reserve with no financial commitment | Joy',
    content: `Hotel Room Blocks with Joy
    Our hotel concierge team is here to help. From curating accommodations to fit every need, to securing hotel room blocks, all without requiring your credit card as a security deposit for your guests.`,
  },
  heroSection: {
    title: 'Introducing Hotel<br />Room Blocks with Joy.',
    bullet1: 'Exclusive hotel room block room rates up to 30% off.',
    bullet2: 'Reserve blocks with no financial commitment.',
    bullet3: 'Personal travel concierge for you and your guests.',
    bullet4: '* Currently only available to residents of the United States.',
    buttonStarted: 'Get Started',
  },
  personalTravelConciergeSection: {
    title: 'Personal Travel Concierge',
    subtitle: 'We do the work, you do the fun.',
    description:
      'Ensuring your guests have a comfortable and convenient place to stay is just one of the countless details of wedding planning. Our concierge team is here to help, from curating accommodations to fit every need, to securing hotel room blocks and helping guests book.',
    buttonStarted: 'Get Started',
    images: [
      {
        title: 'Conrad, New York',
        image: {
          url: 'hotel-room-blocks/PersonalTravelConcierge/Listing.png',
        },
        sm: {
          width: 360,
          height: 270,
        },
        belowSm: {
          width: 360,
          height: 270,
        },
      },
      {
        title: 'Hotel Adagio',
        image: {
          url: 'hotel-room-blocks/PersonalTravelConcierge/Listing1.png',
        },
        sm: {
          width: 360,
          height: 270,
        },
        belowSm: {
          width: 360,
          height: 270,
        },
      },
      {
        title: 'Courtyard San Francisco',
        image: {
          url: 'hotel-room-blocks/PersonalTravelConcierge/Listing2.png',
        },
        sm: {
          width: 360,
          height: 270,
        },
        belowSm: {
          width: 360,
          height: 270,
        },
      },
      {
        title: 'San Francisco Proper',
        image: {
          url: 'hotel-room-blocks/PersonalTravelConcierge/Listing3.png',
        },
        sm: {
          width: 360,
          height: 270,
        },
        belowSm: {
          width: 360,
          height: 270,
        },
      },
    ],
  },
  riskFreeReservationsSection: {
    eyebrow: 'Risk-Free Reservations',
    title: 'Millions of rooms.<br />Zero money down.',
    body: `You’re already spending enough money on the fun. That’s why we let you reserve a block of rooms, no credit card required. In addition to getting you the cheapest rates, we’ll take on the risk—that means no cancelation fees if your hotel room blocks aren't fully booked.`,
    buttonStarted: 'Get Started',
    slide: {
      bgColor: '#E0F9FF',
      bgImage: 'hotel-room-blocks/RiskFreeReservation/Desktop-Risk-free.png',
      bgImageMobile: 'hotel-room-blocks/RiskFreeReservation/Mobile-Risk-free.png',
      eyebrowColor: 'humanaDark4',
      titleColor: 'neutra6',
      bodyColor: 'neutra6',
    },
  },
  exclusiveGroupRatesSection: {
    eyebrow: 'Exclusive Group Rates',
    title: 'Up to 30% off is always something to party about.',
    description: `No matter how small or large your party is, we’ll find the best guest rooms and group rates with your favorite hotels and resorts, whether you’re right in your back yard or planning a destination wedding.`,
    buttonStarted: 'Get Started',
  },
  premiumPerksUpgradesSection: {
    eyebrow: 'Premium Perks & Upgrades',
    title: 'Elevate your stay, right this way.',
    description: `From bridal suite upgrades and complementary spa experiences to special in-room amenities for your wedding guests, our team will open doors and do our best to get you the best.`,
    buttonStarted: 'Get Started',
  },
  expertRecommendationsSection: {
    eyeBrow: 'Expert Recommendations',
    title: 'Hotel blocks curated just for you.',
    content:
      'Tell us your every need, and we’ll present the perfect set of options across multiple price points. Whether you’re looking for something near the wedding venue or far out digs, our experts will help you select and block out the best options for your guests. Your guests book what they need, you enjoy no obligations.',
    buttonStarted: 'Get Started',
    recommendationBestPrice: 'Best Price',
    recommendationNearVenue: 'Near Venue',
    recommendationBestPerks: 'Best Perks',
    recommendationThingsToDo: 'Things To Do',
  },
  streamlinedCommunicationSection: {
    eyeBrow: 'Streamline Communication',
    title: 'The Personal Travel Concierge for your guests.',
    content:
      'Before check-in or after the after party, we provide you with a dedicated concierge team member— a central point of contact for your guests—who can help them navigate their options, book rooms, and answer any and all questions leading up to your event.',
    buttonStarted: 'Get Started',
    bgImage: 'hotel-room-blocks/StreamlinedCommunication/Streamlined-Communication.png',
  },
  weddingWebsiteSection: {
    eyeBrow: 'Wedding Website',
    title: 'Share it with Joy.',
    content:
      'With Joy, you get a beautiful event website to share all the details of your event. Easily share your room blocks on your Joy website or send a direct link and let guests browse and reserve their hotel rooms from right on your website.',
    buttonCreateYourWebsite: 'Create Your Website',
    buttonLearnMore: 'Learn More',
    featuresData: [
      {
        image: 'honeymoon-fund/icon-website-v2.svg',
        title: 'Free Wedding</br>Websites',
      },
      {
        image: 'honeymoon-fund/icon-cards-v2.svg',
        title: 'Save the Dates, Invites & Matching Prints',
      },
      {
        image: 'honeymoon-fund/icon-wand-v2.svg',
        title: 'Powerful</br>Planning Tools',
      },
      {
        image: 'honeymoon-fund/icon-support-v2.svg',
        title: 'Personal</br>Customer Support',
      },
    ],
  },
  textContentBlock: {
    data: [
      {
        title: 'Hotel Room Blocks: The Ultimate Guide for Your Wedding',
        content:
          'Planning your wedding is an exciting yet complex journey with numerous details to manage. Reserving a hotel room block is one key element that can simplify ' +
          'the process for you and your guests. A hotel room block ensures guests have comfortable accommodations at a discounted rate near your venue. With Joy’s concierge ' +
          'service, reserving hotel room blocks has never been easier. From exclusive group rates to a dedicated concierge team, Joy offers a hassle-free way to manage accommodations, ' +
          'allowing you to focus on enjoying your big day.<br/><br/> But what exactly is a hotel room block, and why is it essential for your wedding? Let’s explore how hotel blocks work, ' +
          'the types available, and how Joy can help you secure the best options for your guests.',
      },
      {
        title: 'What is a Hotel Room Block?',
        content:
          'A hotel room block is a set of rooms reserved for your wedding guests at a special rate, often with added perks like complimentary upgrades or amenities. ' +
          'These blocks are handy for hosting a destination wedding or expecting many out-of-town guests. By booking a block, you ensure your guests can access nearby accommodations ' +
          'without scrambling for rooms at the last minute.<br/><br/>When you reserve a hotel block, you typically secure a discounted group rate for a specific number of rooms. ' +
          'Your guests can then book these rooms individually, ensuring they have a comfortable place to stay while attending your wedding. Additionally, reserving a block ' +
          'simplifies transportation logistics, allowing you to coordinate shuttles or shared rides more efficiently.',
      },
      {
        title: 'Tailoring Your Hotel Room Block to Your Wedding',
        content:
          'There’s more than one approach when reserving hotel room blocks for your wedding. Whether you’re celebrating close to home or hosting a destination wedding, ' +
          'understanding your options can make all the difference in ensuring your guests have a comfortable stay. <br/><br /><b>Local Weddings vs. Destination Celebrations </b><br/><br/>' +
          'For a local wedding, convenience is vital. Most couples reserve room blocks at nearby hotels that are easily accessible from the venue. You may want to consider multiple hotels ' +
          'if you expect a large number of guests—say 20 or 30 rooms. Offering options at different prices allows your guests to choose accommodations that fit their preferences and budget. ' +
          'And if you’ve booked a hotel venue for your reception, you can often secure a block of rooms right there as part of your wedding package. <br/><br/> The approach is similar for ' +
          'destination weddings but with a few extra perks. Since your guests are likely traveling from afar, staying at or near your chosen resort or hotel can help make your celebration ' +
          'feel more intimate. Many resorts automatically include room blocks in their wedding packages, ensuring everyone has a spot to relax and enjoy the festivities. If your wedding ' +
          'destination has various accommodation options nearby, it might make sense to offer more choices—especially if you’re hosting a more extensive guest list. This allows guests to ' +
          'select the stay that best suits their travel style.<br/><br/> <b>Courtesy Blocks vs. Contracted Blocks </b> <br/><br/> Hotels generally offer two types of room blocks: courtesy and contracted.<br/><br/>' +
          'A courtesy block is a no-strings-attached option—rooms are held for your guests without any obligation on your part to fill them. This is an excellent choice if you’re unsure how ' +
          'many guests will need accommodations. Some venues even include a courtesy block as part of their package, especially for destination or resort weddings.<br/><br/>' +
          'A contracted room block, however, comes with more formal agreements. You might need to meet specific conditions, like booking a certain number of rooms or depositing. ' +
          'This option can be beneficial if you’re confident in your guest count and want to lock in the best rates, but it’s essential to read the fine print before committing.',
      },
      {
        title: 'Why You Need a Hotel Room Block for Your Wedding',
        content:
          'Booking a hotel room block offers several key advantages: <br/><br/> <ol>' +
          '<li><b>Convenience for Your Guests:</b> Your guests won’t have to worry about finding accommodations; they’ll have a reserved spot at a hotel close to your venue.</li>' +
          '<li><b>Discounted Rates:</b> Hotel blocks often come with discounted group rates, saving guests money while offering them high-quality accommodations.</li>' +
          '<li><b>Streamlined Coordination:</b> When your guests stay at the exact location, it’s easier to arrange transportation, coordinate events, and ensure everyone arrives on time for your wedding day.</li>' +
          '<li><b>Enhanced Guest Experience:</b> By offering your guests a wedding hotel block, you improve their experience, providing a more enjoyable stay. Many hotels offer added perks like welcome amenities for your guests or upgrades for the bride and groom.</li></ol>' +
          '<br/>With Joy’s concierge service, these benefits are just the beginning. You can book your block without any financial risk and enjoy the peace of mind that your guests’ accommodations are taken care of.',
      },
      {
        title: 'Joy’s Hotel Room Block Service: Exclusive Perks and Benefits',
        content:
          'Joy simplifies reserving hotel room blocks, providing you with a dedicated travel concierge, exclusive group rates, and premium perks. Here are some of the standout features of Joy’s hotel room block service:<br/><br/>' +
          '<ul><li><b>Exclusive Group Rates:</b> Save up to 30% off hotel room rates with Joy. Whether your guests stay at a luxury resort or a budget-friendly hotel, Joy ensures they get the best rate possible.</li>' +
          '<li><b>Risk-Free Reservations:</b> Joy allows you to reserve blocks of rooms with no financial commitment. No credit card is required, and you won’t face cancellation fees if the block isn’t fully booked.</li>' +
          '<li><b>Personal Travel Concierge:</b> Joy’s concierge team does the heavy lifting for you, helping you secure hotel blocks and ensuring your guests have a seamless booking experience. From booking assistance to answering guest questions, Joy’s concierge takes the stress off your plate.</li>' +
          '<li><b>Premium Perks & Upgrades:</b> As part of Joy’s service, you may qualify for premium perks, such as complimentary bridal suite upgrades, spa experiences, and exceptional in-room amenities for your guests.</li>' +
          '<li><b>Streamlined Communication:</b> Joy provides a central point of contact for your guests, ensuring they have a straightforward process for booking their rooms. Your dedicated concierge can help your guests navigate their options and answer any questions.</li></ul>',
      },
      {
        title: 'Types of Hotel Room Blocks',
        content:
          'When reserving hotel blocks, it’s essential to understand the different types available. Each type has its pros and cons, so it’s vital to choose the one that best suits your needs:' +
          '<ol><li><br/><b>Courtesy Block</b> <br/><br/>A courtesy block is the most flexible type of room block. It allows you to reserve rooms for your guests without any financial obligation. The hotel will hold ' +
          'a specific number of rooms for a certain period, and guests can book them at a discounted rate. If the rooms aren’t filled, you have no penalty or financial responsibility. However, availability is not guaranteed once the hotel fills up.</li>' +
          '<li><b>Guaranteed Block</b><br/><br/>A guaranteed block, on the other hand, requires a financial commitment. You agree to a certain number of rooms; if those rooms aren’t booked, you may be responsible for paying for them. This block type is more suited to larger weddings where you’re confident that most rooms will be booked.</li>' +
          '<li><b>Attrition Block</b><br/><br/>With an attrition block, you must fill a specific percentage of the rooms in the block (typically 80-90%). You’ll be responsible for paying for the difference if you don’t meet that percentage. ' +
          'This block type is more common for more significant events, where there’s a good chance of filling most of the rooms.<br/><br/> Understanding these options helps you choose the best type of hotel block for your wedding. With Joy, your concierge can help you decide which block makes the most sense for your needs.</li></ol>',
      },
      {
        title: 'How to Reserve a Hotel Room Block Using Joy',
        content:
          'Reserving a hotel room block with Joy is straightforward to save you time and stress. Here’s how it works:<br/><br/>' +
          '<ol><li><b>Share Your Hotel Preferences:</b> Share details about your wedding dates, venue, and preferred hotel locations with Joy’s concierge team. Be sure to let them know if you have specific needs, such as proximity to the venue or desired amenities.</li>' +
          '<li><b>Receive Tailored Options:</b> Joy’s team will research and present a curated list of hotels that match your preferences. You’ll receive discounted rates across multiple price points, allowing you to choose the best options for your guests.</li>' +
          '<li><b>Confirm and Reserve:</b> Once you’ve selected the hotel(s) and room block sizes, Joy will handle the reservation process. This includes securing the rooms and setting up a dedicated guest booking link.</li>' +
          '<li><b>Share with Your Guests:</b> You can easily share the booking link with your guests through your Joy wedding website, making it convenient for them to book their rooms. Alternatively, you can send the link via email or messaging.</li>' +
          '<li><b>Enjoy Peace of Mind:</b> With Joy managing your room block reservations, you can relax knowing that your guests’ accommodations are taken care of.</li></ol>',
      },
      {
        title: 'Tips for Reserving Hotel Room Blocks',
        content:
          'Reserving hotel room blocks can be a breeze with little planning. Here are some tips to help ensure a smooth process:<br/><br/>' +
          '<ul><li><b>Start Early:</b> The earlier you begin the process, the better. Hotels can fill up quickly, especially during popular wedding seasons or holiday weekends. Booking early increases the chances of securing the best rates and availability.</li>' +
          '<li><b>Estimate Guest Needs:</b> A good rule of thumb is to reserve rooms for 30-40% of your total guest list. For example, if you’re expecting 100 out-of-town guests, booking 30-40 rooms should cover their needs.</li>' +
          '<li><b>Consider Multiple Hotels:</b> If your guest list includes people with varying budgets, consider reserving blocks at two or more hotels. This allows your guests to choose accommodations that fit their budget while staying close to your venue.</li>' +
          '<li><b>Negotiate Perks:</b> Many hotels offer complimentary perks, such as suite upgrades, free breakfasts, or welcome amenities for your guests. Don’t be afraid to ask for these extras when reserving your block.</li>' +
          '<li><b>Communicate Clearly:</b> Once your blocks are reserved, make sure your guests know how to book their rooms. Share the booking link through your wedding website or invitations, and remind guests to book early to secure the discounted rate.</li></ul>',
      },
      {
        title: 'Conclusion: Make Your Wedding Day Stress-Free with Joy',
        content:
          'Booking a hotel room block is essential in ensuring your wedding guests have a comfortable, convenient place to stay. With Joy, you can take advantage of exclusive group rates, risk-free reservations, and premium perks. ' +
          'Joy’s concierge team will handle all the details, giving you one less thing to worry about.<br/><br/>Whether you’re hosting a local celebration or a destination wedding, Joy’s hotel room block service simplifies the process ' +
          'and ensures your guests are well cared for. Contact Joy’s team to reserve your hotel room block today.',
      },
    ],
    seeLess: 'See Less',
    readMore: 'Read More',
  },
} as const;
